


























import { defineComponent, ref } from '@vue/composition-api';
import {
  createAnnouncement,
  updateAnnouncement,
} from '@/appsync/service/AnnouncementMutationService';
import { fetchAnnouncements } from '@/appsync/service/AnnouncementQueryService';
import DataTable from '@/components/organisms/DataTable.vue';
import { useAnnouncementTable } from '@/composables/use-announcement-table';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import { i18n, useI18n } from '@/plugins/i18n/i18n';
import { commonModule } from '@/store/modules/CommonStore';
import { editingCardModule } from '@/store/modules/EditingCardStore';
import { Announcement, AnnouncementForDisplay, LoginInfo } from '@/types/type';
import { getDisabledRoutes, _BooleanEnum2boolean } from '@/utils/CommonUtils';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

export default defineComponent({
  components: { DataTable, ErrorMessagePageTemplate },
  setup(props, context) {
    const {
      announcements,
      getAnnouncementFields,
      headers,
      sortBy,
      sortDesc,
      defaultItem,
      updateAnnouncements,
    } = useAnnouncementTable();

    const loading = ref(true);
    const notEnabledImgAltMessage: String = 'Page Not Enabled';
    const notEnabledImgName: String = 'page-not-enabled';
    const notEnabledImgWidth: String = '250px';
    const notEnabledImgHeight: String = '186px';
    const notEnabledTitleText = useI18n('pageNotEnabled.titleText');
    const notEnabledSubText = useI18n('pageNotEnabled.subText');
    const isAnnouncementEnabled = ref(false);

    async function isAnnouncementEnabledFunc() {
      const { tenant, landscape } = commonModule.tenantLandscape;
      const { loginName } = commonModule.loginInfo;
      const disabledRoutes = await getDisabledRoutes(
        tenant,
        landscape,
        loginName
      );
      if (
        !disabledRoutes.includes(PAGE_PATH_BY_NAME.commonsettingAnnouncement)
      ) {
        isAnnouncementEnabled.value = true;
        updateList();
      }
      loading.value = false;
    }
    isAnnouncementEnabledFunc();

    editingCardModule.setFields(getAnnouncementFields);
    editingCardModule.setName('announcement');

    const updateList = () => {
      const { tenant, landscape } = commonModule.tenantLandscape;
      fetchAnnouncements(tenant, landscape).then(updateAnnouncements);
    };

    const onCreate = async (data: Announcement) => {
      const { tenant, landscape } = commonModule.tenantLandscape;
      await createAnnouncement(data, tenant, landscape);
      await updateList();
    };

    const onUpdate = async (data: AnnouncementForDisplay) => {
      await updateAnnouncement(data);
      await updateList();
    };

    return {
      loading,
      isAnnouncementEnabled,
      notEnabledImgAltMessage,
      notEnabledImgName,
      notEnabledImgWidth,
      notEnabledImgHeight,
      notEnabledTitleText,
      notEnabledSubText,
      announcements,
      headers,
      defaultItem,
      onCreate,
      onUpdate,
      sortBy,
      sortDesc,
    };
  },
});
